import { useAuth } from '../hooks/useAuth'
import { useAppStore } from '../stores/app'
import { SettingsOrganizationSection } from '../components/settings/SettingsOrganizationSection'
import { SettingsProfileSection } from '../components/settings/SettingsProfileSection'
import { SettingsAccountSection } from '../components/settings/SettingsAccountSection'
import { SettingsAgentsSection } from '../components/settings/SettingsAgentsSection'
import { SettingsPipelinesSection } from '../components/settings/SettingsPipelinesSection'
import { SettingsVisualSection } from '../components/settings/SettingsVisualSection'
import { SettingsBrandSection } from '../components/settings/SettingsBrandSection'
import { SettingsTeamSection } from '../components/settings/SettingsTeamSection'
import { SettingsBillingSection } from '../components/settings/SettingsBillingSection'
import { SettingsAPIKeysSection } from '../components/settings/SettingsAPIKeysSection'
import { LoadingSpinner } from '../components/ui/LoadingSpinner'

export function SettingsPage() {
  const { loading: authLoading } = useAuth()
  const currentUser = useAppStore((state) => state.currentUser)
  const isAdmin = currentUser?.role === 'admin'

  if (authLoading) {
    return (
      <div className="p-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-slate-800">Configuración</h1>
          <p className="text-slate-500 mt-1">Configura tu organización y preferencias</p>
        </div>
        <div className="flex justify-center items-center py-12">
          <LoadingSpinner size="lg" />
        </div>
      </div>
    )
  }

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-800">Configuración</h1>
        <p className="text-slate-500 mt-1">Configura tu organización y preferencias</p>
      </div>

      <div className="space-y-6">
        <SettingsOrganizationSection />
        <SettingsProfileSection />
        <SettingsAccountSection />
        {isAdmin && (
          <>
            <SettingsBillingSection />
            <SettingsTeamSection />
            <SettingsAPIKeysSection />
            <SettingsAgentsSection />
            <SettingsPipelinesSection />
            <SettingsVisualSection />
            <SettingsBrandSection />
          </>
        )}
      </div>
    </div>
  )
}
